import logo from "./logo.svg";
import "./App.css";
import Layout from "./components/layout";

function App() {
  return <Layout></Layout>;
}

export default App;
